import React, { Component } from 'react';
import DadosConsultoria from '../components/consultoria/dados_consultoria';
import ConsultoriasPrestadas from '../components/consultoria/consultorias_prestadas';
import Header from '../components/header/header';
import Banner from '../components/header/banner';
import Footer from '../components/statics/footer';
import {connect} from 'react-redux';
import * as CategoryProvider from '../providers/categoryProvider';
import Testimonials from '../components/consultoria/testimonials';


class HomeScreen extends Component {
  constructor(props){
    super(props);
  }
  render() {
      return (
        <div>
            {/* <Header /> */}
            <Banner imagem={require('../imagens/banner.jpg')}/>
            <DadosConsultoria />
            <ConsultoriasPrestadas list={this.props.categories}/>
            <Testimonials />
            <Footer />
        </div>
      );
    }
  }

const mapStateToProps = (state)=>{
    return {
      categories:state.category.list,
    }
}
export default connect(mapStateToProps)(HomeScreen);
